(function () {
  var roots = document.querySelectorAll('[data-pdpup]');
  if (!roots.length) return;
  var gt = function (name, params) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) {}
  };
  roots.forEach(function (root) {
    var v = root.getAttribute('data-upsell-variant') || 'a';
    window.__upsellVariant = v;
    try {
      if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { upsell_variant: v });
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('set', 'upsell_variant', v);
    } catch (e) {}
    var seen = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !seen) { seen = true; gt('upsell_view', { upsell_variant: v }); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(root);
    }
    var markAdded = function (vid) {
      var card = root.querySelector('[data-pdpup-vid="' + vid + '"]');
      if (!card) return;
      card.classList.add('is-added');
      setTimeout(function () { card.classList.remove('is-added'); }, 2600);
      var disc = root.getAttribute('data-discounted') === 'true';
      var list = parseFloat(card.getAttribute('data-price')) || 0;
      var sale = parseFloat(card.getAttribute('data-sale')) || 0;
      var shown = disc && sale > 0 ? sale : list;
      gt('upsell_tumbler', {
        tumbler_variant: card.getAttribute('data-color') || '',
        tumbler_brand: card.getAttribute('data-brand') || '',
        price: shown,
        discounted: disc && sale > 0,
        pdp_variant: window.__pdpVariant || '',
        upsell_variant: v
      });
      try { if (typeof window.clarity === 'function') window.clarity('event', 'upsell_tumbler'); } catch (e) {}
    };
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
          if (e && e.source === 'product-form' && e.productVariantId) markAdded(String(e.productVariantId));
        });
      }
    } catch (e) {}
    /* the whole card adds to cart: a click anywhere on it (image, name, price) submits that tumbler's own form, so the theme's product-form
       does the AJAX add and opens the cart drawer; buttons and links keep their own behavior */
    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || t.closest('button, a, input, select, textarea, label')) return;
      var card = t.closest('.pdpup__card');
      if (!card) return;
      var form = card.querySelector('form'), btn = form && form.querySelector('.pdpup__add');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
    });
    root.addEventListener('submit', function (ev) {
      var form = ev.target;
      var idEl = form && form.querySelector ? form.querySelector('[name="id"]') : null;
      gt('upsell_add_click', { upsell_variant: v, variant_id: idEl ? idEl.value : '' });
      var setAttr = function (tries) {
        var attrs = { upsell_variant: v };
        if (window.__pdpVariant) attrs.pdp_variant = window.__pdpVariant;
        try {
          fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
            .then(function (r) { return r.json(); })
            .then(function (c) { if (tries > 0 && (!c.attributes || c.attributes.upsell_variant !== v)) setTimeout(function () { setAttr(tries - 1); }, 1500); })
            .catch(function () {});
        } catch (e) {}
      };
      var done = false;
      var once = function () { if (done) return; done = true; setAttr(3); };
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { var un = subscribe(PUB_SUB_EVENTS.cartUpdate, function () { once(); if (typeof un === 'function') un(); }); }
      } catch (e) {}
      setTimeout(once, 2500);
    }, true);
  });
})();
